module.exports = __webpack_public_path__ + "static/media/045.fb0e0c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/045.jpg
// module id = 340
// module chunks = 0